import HealthScoreQuestionnaire from "@/features/HealthScore/components/HealthScoreQuestionnaire";
import {
  Question,
  QuestionnaireAnswer,
  QuestionType,
  QuestionnaireType,
  FamilyHistoryCondition,
  YesNoAnswer,
  ConditionsCount,
} from "@/features/HealthScore/components/HealthScoreQuestionnaire/types";
import { useTranslation } from "react-i18next";

export default function HealthHistoryQuestionnaire() {
  const { t } = useTranslation();

  const HEALTH_HISTORY_QUESTIONS: Question[] = [
    {
      type: QuestionType.FAMILY_HISTORY,
      multiSelect: true,
      meta: {
        values: [
          FamilyHistoryCondition.DIABETES,
          FamilyHistoryCondition.HIGH_BLOOD_PRESSURE,
          FamilyHistoryCondition.CORONARY_ARTERY_DISEASE,
          FamilyHistoryCondition.NONE,
        ],
      },
    },
    {
      type: QuestionType.FAMILY_TUBERCULOSIS,
      meta: {
        values: [YesNoAnswer.YES, YesNoAnswer.NO],
      },
    },
    {
      type: QuestionType.CONDITIONS,
      meta: {
        values: [
          ConditionsCount.NONE,
          ConditionsCount.ONE,
          ConditionsCount.TWO_PLUS,
        ],
      },
    },
    {
      type: QuestionType.HIV_TB,
      meta: {
        values: [YesNoAnswer.YES, YesNoAnswer.NO],
      },
    },
  ];

  const handleSubmit = async (answers: QuestionnaireAnswer[]) => {
    const payload = {
      questionnaireType: QuestionnaireType.HEALTH_HISTORY,
      value: answers,
    };
    // TODO: Replace with actual API call
    console.log("Submitting health history answers:", payload);
  };

  return (
    <HealthScoreQuestionnaire
      questions={HEALTH_HISTORY_QUESTIONS}
      translationPrefix="HealthHistory.questionnaire"
      onSubmit={handleSubmit}
      title={t("HealthHistory.questionnaire.title")}
    />
  );
}
